module.exports = __webpack_public_path__ + "static/img/ls_wx.c98b547.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ls_wx.jpg
// module id = 52gh
// module chunks = 1